export const importDataTranslationJP = {
  ImportDataPage: {
    head_title: 'レジデータ取り込み',
    description_1: '(FTProのデータ取り込み）',
    description_2: '以下のファイルを同時に一括で取りこんでください。',
    description_3: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -',
    description_4: '１．メニューマスタ（TMS_MST_MENU.csv）',
    description_5: '２．メニュー構成マスタ（TMS_MST_MENUCONST.csv）',
    description_6: '３．ＭＬＵマスタ（TMS_MST_MLU.csv）',
    description_7: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -',
    description_8: '※【注意】パターンコードのCSVを取り込むようにしてください。',
    Button: {
      change_registration_pattern_name: 'レジパターン名変更',
      selected_files: 'ファイルを選択',
      file_upload: 'ファイルアップロード',
    },
    Message: {
      file_not_select: '選択されていません',
      import_successfully: '正常終了：ファイルの取り込みが完了しました。',
      invalid_file_name: 'ファイル名に誤りがあります。ご確認ください。',
    },
  },
  ChangeRegistrationPatternNameModal: {
    head_title: 'レジパターン名変更',
    Button: {
      save: '保存',
    },
    Table: {
      Header: {
        pattern_number: 'パターン番号',
        pattern_name: 'パターン名',
        version: 'バージョン',
      },
    },
  },
};
